import { Eye, EyeOff } from "lucide-react";
import React, { useState } from "react";
import Button from "../Button";

const PasswordInput = React.forwardRef((props, ref) => {
  const [viewPassword, setViewPassword] = useState(false);

  const {
    containerCls = "",
    inputProps = {},
    label,
    error,
    defaultValue,
  } = props;

  return (
    <div className={`my-4 ${containerCls}`}>
      {label ? <div className="pb-1 text-gray-800">{label}</div> : null}

      <div className="relative">
        <input
          type={viewPassword ? "text" : "password"}
          className={`px-2 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 back_link transition ease-in-out delay-150 w-full ${
            error ? "" : ""
          }`}
          defaultValue={defaultValue}
          {...inputProps}
        />

        <Button
          buttonProps={{
            onClick: () => setViewPassword((prev) => !prev),
            className:
              "absolute top-0.5 right-0.5 text-gray-400 bg-white h-10 px-4 rounded-md",
          }}
        >
          {viewPassword ? <Eye /> : <EyeOff />}
        </Button>
      </div>

      {error ? (
        <div className="pt-1.5 text-red-600 text-sm">{error}</div>
      ) : null}
    </div>
  );
});

export default PasswordInput;
